import { getApp, getPlatform } from 'src/config/environment';
import type { WorkflowDefinition } from 'src/distribution_platforms/features/workflow_definition';
import {
  getWorkflowDefinition,
  getWorkflowTypeForOrganization,
} from 'src/distribution_platforms/features/workflows';
import { useEffectiveOrganization } from 'src/hooks/use_auth';
import type { WorkflowType } from 'src/types/workflows';

/**
 * Returns workflow type for the effective organization.
 * Effective org for LDT is derived from selected org (CS/Sales) or user's org (non-CS/Sales).
 * For other platforms, the workflow type is not relevant.
 */
export function useWorkflowType(): WorkflowType {
  const effectiveOrg = useEffectiveOrganization();

  return getWorkflowTypeForOrganization(effectiveOrg, getApp());
}

/**
 * Returns the workflow definition based on the current platform type.
 */
export function useWorkflow(): WorkflowDefinition {
  const workflowType = useWorkflowType();

  return getWorkflowDefinition(getPlatform(), workflowType);
}

/**
 * Whether the current platform/context allows creating an order.
 * Uses the workflow definition (same for LDT and SaMD).
 */
export function useCanCreateOrder(): boolean {
  const workflow = useWorkflow();
  return workflow.canCreateOrder;
}
